"use client";

import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { ChartBarIcon, MegaphoneIcon } from '@phosphor-icons/react'
import { ToolbarTabLink } from '@/src/components/layout/ToolbarTabToggle'

export const Route = createFileRoute('/_manage/manage/admin/dashboard')({
  component: AdminDashboardLayout,
})

function AdminDashboardLayout() {
  const location = useLocation()
  const currentPath = location.pathname
  
  // Determine active tab based on current path
  const isAnnouncements = currentPath.includes('/announcements')
  const isStatistics = !isAnnouncements

  return (
    <div className="bg-background text-foreground">
      <AdminToolbar>
        <AdminToolbar.Left>
          <div className="flex gap-1">
            <ToolbarTabLink to="/manage/admin/dashboard" active={isStatistics}>
              <ChartBarIcon className="h-4 w-4" />
              Statistics
            </ToolbarTabLink>
            <ToolbarTabLink to="/manage/admin/dashboard/announcements" active={isAnnouncements}>
              <MegaphoneIcon className="h-4 w-4" />
              Announcements
            </ToolbarTabLink>
          </div>
        </AdminToolbar.Left>
      </AdminToolbar>

      <Outlet />
    </div>
  )
}
